import { State as AppState } from '..';
import { Player } from '../../services/sculkwire';

export const selectAllPlayers = (state: AppState): Player[] => Object.values(state.players.player);

export const selectOnlinePlayers = (state: AppState): Player[] | null => state.players.online;

export const selectPlayer = (uuid: string) => (state: AppState): Player | undefined => state
  .players.player[uuid];
